<template>
    <div v-if="Object.keys(errors).length > 0" class="container-fluid mb-4 p-0">
        <div class="alert alert-custom alert-light-danger fade show mb-0 shadow-sm" role="alert">
            <div class="alert-icon">
                <i class="fas fa-exclamation-circle"></i>
            </div>
            <div class="alert-text">
                <h4 v-if="title" class="alert-heading">{{ title }}</h4>
                <div v-for="error in errors">
                    <div v-if="Array.isArray(error)">
                        <div v-for="e in error" v-html="e"/>
                    </div>
                    <div v-else v-html="error"/>
                </div>
            </div>
            <div class="alert-close" v-if="showClose">
                <button type="button" class="close" data-dismiss="alert" aria-label="Close">
                    <span aria-hidden="true"><i class="ki ki-close"></i></span>
                </button>
            </div>
        </div>
    </div>
</template>

<script>
export default {
    props: {
        title: String,
        showClose: Boolean,
        errors: {
            types: [Object, Array],
            default: () => {
                return []
            },
        },
    },
}
</script>
